import React, { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { toast } from "react-toastify";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";

import { auth } from "../../../../firebase/firebase";
import { customLogger } from "../../../../utils/Logger";
import apiInstance from "../../../../services/apiService";
import GradientButton from "../../../../components/common/UI/GradientButton";
import CountriesModal from "../../../../components/common/CountriesModal";
import VerifyRegisterOTP from "./VerifyRegisterOTP";

import "./index.scss";

interface Country {
  isoCode: string;
  phoneCode: string;
  name: string;
  iso3Code: string;
}

const RegisterNumber = ({ handleBackClick }: { handleBackClick: any }) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [otpSentFromBackend, setSendOTPfromBE] = useState<boolean>(false);
  const [currentScreen, setCurrentScreen] = useState("register");
  const [loading, setLoading] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState<
    Country | null | undefined
  >({
    isoCode: "US",
    phoneCode: "1",
    name: "United States",
    iso3Code: "USA",
  });

  useEffect(() => {
    const initRecaptcha = async () => {
      try {
        if (window.recaptchaVerifier) {
          window.recaptchaVerifier.clear();
          window.recaptchaVerifier = undefined;
        }

        window.recaptchaVerifier = new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible",
            callback: () => console.log("reCAPTCHA solved"),
            "expired-callback": () => {
              window.recaptchaVerifier?.clear();
              window.recaptchaVerifier = undefined;
            },
          },
        );

        await window.recaptchaVerifier.render();
      } catch (err) {
        console.error("reCAPTCHA init failed:", err);
      }
    };

    initRecaptcha();

    return () => {
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = undefined;
      }
    };
  }, []);

  const sendOTPfromBackend = async (phoneNumber: string) => {
    try {
      const url = "auth/app/sendOtpForNumber";
      const response = await apiInstance.post(url, { phoneNumber });
      // debugger;
      if (response.status === 200) {
        setSendOTPfromBE(true);
        setCurrentScreen("verify");
      }
    } catch (err: any) {
      toast.error(err?.message || "There was an error. Please try again");
      customLogger("error sending OTP from Backend", err);
    } finally {
      setLoading(false);
    }
  };

  const sendOTP = async () => {
    if (!selectedCountry) {
      return toast.error("Please select a country.");
    }

    if (!phoneNumber || phoneNumber.length < 6) {
      return toast.error("Please enter a valid phone number.");
    }

    setLoading(true);
    const fullPhoneNumber = `+${selectedCountry.phoneCode}${phoneNumber}`;

    try {
      const appVerifier = window.recaptchaVerifier;

      if (!appVerifier) {
        await sendOTPfromBackend(fullPhoneNumber);
        return;
      }

      const confirmationResult = await signInWithPhoneNumber(
        auth,
        fullPhoneNumber,
        appVerifier!,
      );

      window.confirmationResult = confirmationResult;
      toast.success("OTP sent successfully!");
      setCurrentScreen("verify");
    } catch (error: any) {
      // debugger;
      console.error("Error sending OTP from firebase:", error);

      window.recaptchaVerifier?.clear();
      window.recaptchaVerifier = undefined;

      await sendOTPfromBackend(fullPhoneNumber);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!window.recaptchaVerifier) {
  //     window.recaptchaVerifier = new RecaptchaVerifier(
  //       auth,
  //       "recaptcha-container",
  //       {
  //         size: "invisible",
  //         callback: () => {
  //           console.log("reCAPTCHA solved");
  //         },
  //       },
  //     );
  //   }

  // return () => {
  //   window.recaptchaVerifier?.clear();
  //   // window.recaptchaVerifier = null;
  // };
  // }, []);

  return (
    <>
      <div id="recaptcha-container"></div>

      {currentScreen === "register" ? (
        <div className="add-existing-number">
          <Flex align="center" gap={20}>
            <div className="icon-container" onClick={handleBackClick}>
              <ArrowLeftOutlined />
            </div>

            <div>
              <h1 className="title">Register Number</h1>
              <p className="subtitle">
                Enter number that is already registered on efone
              </p>
            </div>
          </Flex>

          <div className="input-card">
            <div
              className="country-select"
              onClick={() => setModalVisible(true)}
            >
              <div className="country-left">
                <ReactCountryFlag
                  svg
                  countryCode={
                    selectedCountry?.isoCode || selectedCountry?.iso3Code || ""
                  }
                />

                <span>
                  {`${selectedCountry?.name} (+${selectedCountry?.phoneCode})`}
                </span>
              </div>
            </div>

            <input
              type="tel"
              placeholder="Phone number"
              className="phone-input"
              disabled={loading}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>

          <GradientButton loading={loading} onClick={sendOTP}>
            Continue
          </GradientButton>
        </div>
      ) : (
        <VerifyRegisterOTP
          phoneNumber={`+${selectedCountry?.phoneCode}${phoneNumber}`}
          handleBackClick={() => setCurrentScreen("register")}
          otpSentFromBackend={otpSentFromBackend}
        />
      )}

      <CountriesModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSelect={setSelectedCountry}
      />
    </>
  );
};

export default RegisterNumber;
